<template>
  <div class="bio-link-whatsapp" :style="{color: sectionTextColor}">
    <span class="bio-link-whatsapp-icon">
      <v-icon color="#25D366" size="22">mdi-whatsapp</v-icon>
    </span>
    <div class="bio-link-whatsapp-header-text">
      <p v-if="item.description" class="bio-link-whatsapp-title all-text" :style="{color: sectionTextColor}">{{ item.description }}</p>
      <p v-if="destinationLabel" class="bio-link-destination" :style="{color: sectionTextColor}">{{ destinationLabel }}</p>
    </div>
    <v-icon size="20" :color="sectionTextColor" class="bio-link-whatsapp-message-icon">mdi-message-outline</v-icon>
  </div>
</template>

<script>
export default {
  name: 'WhatsappLinkCard',
  props: {
    item: { type: Object, required: true },
    sectionTextColor: { type: String, default: '#FFFFFF' },
    destinationLabel: { type: String, default: null },
  },
}
</script>

<style scoped>
.bio-link-whatsapp {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1rem;
  /* Matches .bio-link-simple's min-height - see that file's comment. */
  min-height: 4.5rem;
}
.bio-link-whatsapp-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 0.85rem;
  background: rgba(37, 211, 102, 0.14);
  flex-shrink: 0;
}
.bio-link-whatsapp-header-text {
  flex: 1;
  min-width: 0;
}
.bio-link-whatsapp-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin: 0;
}
.bio-link-destination {
  opacity: 0.7;
  font-size: 0.75em;
  margin: 0.1rem 0 0;
}
.bio-link-whatsapp-message-icon {
  flex-shrink: 0;
}
</style>
